import { gql, useQuery } from "@apollo/client";

export interface LandingPageForDropdown {
  id: string;
  slug: string;
  headline: string;
  isActive: boolean;
}

export const ALL_LANDING_PAGES_FOR_DROPDOWN = gql`
  query AllLandingPagesForDropdown($page: Int!, $perPage: Int!) {
    allLandingPages(page: $page, perPage: $perPage, filter: { status: "active" }) {
      id
      slug
      headline
      isActive
    }
  }
`;

export function useLandingPagesForDropdown() {
  const { data, loading, error, refetch } = useQuery<{
    allLandingPages: LandingPageForDropdown[];
  }>(ALL_LANDING_PAGES_FOR_DROPDOWN, {
    variables: { page: 0, perPage: 100 },
    fetchPolicy: "cache-and-network",
  });

  return {
    landingPages: data?.allLandingPages ?? [],
    loading,
    error,
    refetch,
  };
}
